<template>
  <Banner :type="alertType" class="delayed-show-lr">
    <template #title>
      <section class="has-text-grey-darker">
        <div class="has-text-weight-semibold">{{ alertTitle }}</div>
        <div class="has-text-weight-normal">
          {{ alertMessage }}
        </div>
      </section>
    </template>
    <template #action-button>
      <ButtonView
        v-if="canShowReloadButton"
        :data-e2e="AICypressAttribute.buttons.CLARA_FAILED_RESPONSE_RELOAD_QUESTION"
        class="button is-primary is-light m-r-10"
        @click="onReloadClicked"
      >
        <span class="has-text-weight-semibold">{{ $t('ai.reload') }}</span>
      </ButtonView>
      <ButtonView
        :data-e2e="AICypressAttribute.buttons.CLARA_FAILED_RESPONSE_EDIT_QUESTION"
        class="button is-primary is-light"
        @click="onEditClicked"
      >
        <span class="has-text-weight-semibold">{{ $t('ai.edit-question') }}</span>
      </ButtonView>
    </template>
  </Banner>
</template>

<script>
import { ClaraMessageStatusType } from '@/modules/ai/constants/ClaraMessageStatusType';
import { ClaraMessageObject } from '@/modules/ai/models/ClaraMessageObject';
import { AICypressAttribute } from '@/modules/ai/constants/AICypressAttribute';
import Banner from '@/modules/core/ui/components/Banner.vue';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';
import { BannerType } from '@/modules/core/ui/constants/BannerType';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ClaraFailedResponseBanner',
  emits: ['reload-question', 'edit-question'],
  components: {
    Banner,
    ButtonView
  },
  props: {
    message: {
      type: ClaraMessageObject,
      required: true
    }
  },
  static: {
    AICypressAttribute
  },
  computed: {
    canShowReloadButton() {
      return this.message.isFailed;
    },
    alertTitle() {
      switch (this.message.status) {
        case ClaraMessageStatusType.NO_MATCH:
          return this.$t('ai.nothing-found');
        case ClaraMessageStatusType.NO_RELEVANCE:
          return this.$t('ai.oops-this-is');
        case ClaraMessageStatusType.FAILED:
        default:
          return this.$t('ai.oops-something');
      }
    },
    alertMessage() {
      switch (this.message.status) {
        case ClaraMessageStatusType.NO_MATCH:
          return this.$t('ai.clara-couldnt-find');
        case ClaraMessageStatusType.NO_RELEVANCE:
          return this.$t('ai.try-asking-a');
        case ClaraMessageStatusType.FAILED:
        default:
          return this.$t('ai.something-didnt-work');
      }
    },
    alertType() {
      switch (this.message.status) {
        case ClaraMessageStatusType.NO_MATCH:
        case ClaraMessageStatusType.NO_RELEVANCE:
          return BannerType.IS_PRIMARY;
        case ClaraMessageStatusType.FAILED:
        default:
          return BannerType.IS_DANGER;
      }
    }
  },
  methods: {
    onReloadClicked() {
      this.$emit('reload-question');
    },
    onEditClicked() {
      this.$emit('edit-question');
    }
  }
};
</script>
